import './index.scss';
import { Button } from 'ii-react-sdk/form_components';
import React from 'react';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useDocumentsView } from '../../provider';
const DocSelect = ({ document, documents, icon, setDocument }) => {
    const { swapDocs } = useDocumentsView();
    const { ref: showHideRef, isComponentVisible: isDocSelectOpen, setIsComponentVisible: setIsDocSelectOpen, } = useComponentVisible(false);
    const toggleDocsDisplay = () => {
        setIsDocSelectOpen(!isDocSelectOpen);
    };
    return (React.createElement("div", { className: 'document-filter' },
        React.createElement("div", { className: 'header document-title', "data-testid": 'document-title', onClick: () => toggleDocsDisplay() },
            React.createElement("span", { className: 'icon' },
                React.createElement("i", { className: icon })),
            React.createElement("span", { className: 'document-title overflow-ellipsis' }, document === null || document === void 0 ? void 0 : document.fileName),
            isDocSelectOpen && (React.createElement("div", { className: 'document-switch-dropdown', "data-testid": 'document-switch-dialog', ref: showHideRef }, documents.map((doc, index) => {
                const isSelectedDoc = doc.fileId === (document === null || document === void 0 ? void 0 : document.fileId);
                return React.createElement("div", { "data-testid": `doc-compare-switcher-doc-${index}`, key: `${doc.fileId}-document-select`, className: 'select-item', onClick: () => setDocument(doc) },
                    React.createElement("span", { className: 'icon' }, isSelectedDoc &&
                        React.createElement("i", { className: icon })),
                    React.createElement("span", { className: 'overflow-ellipsis', title: doc.fileName }, doc.fileName));
            })))),
        React.createElement(Button, { className: 'doc-swap-button', onClick: swapDocs },
            React.createElement("i", { className: 'fas fa-exchange' }))));
};
export default DocSelect;
